import React, { useState } from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import FuneralTabMobile from '../../../../components/Sangjo-Ujieon/FuneralTabMobile';

const FuneralMethodsMobile = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="장례정보" />

        {/* Main Content Section */}
        <div className="funeral-methods-mobile-section">

          {/* Funeral Methods Section */}
          <div className="funeral-methods-procedures-section sky-hall-special-room-mobile-pricing-section">
            <FuneralTabMobile selectedHall="장례방법" />

            {/* Content Display Area */}
            <div className="funeral-methods-content-area">

              {/* Funeral Methods Grid */}
              <div className="funeral-methods-methods-grid">

                {/* Burial Method */}
                <div className="funeral-methods-method-item">
                  <div className="funeral-methods-method-image-container">
                    <img
                      src="/images/fu1.png"
                      alt="매장"
                      className="funeral-methods-method-image"
                    />
                  </div>
                  <h5 className="funeral-methods-method-title">매장</h5>
                  <div className="funeral-methods-method-content">
                    <p className="funeral-methods-method-description">
                      시신(임신 4개월 이후의 태아 포함)이나 유골을 땅에 묻는 것으로, 묘지와 분묘의 종류가 있다.
                    </p>
                  </div>
                </div>

                {/* Cremation Method */}
                <div className="funeral-methods-method-item">
                  <div className="funeral-methods-method-image-container">
                    <img
                      src="/images/fu2.png"
                      alt="화장"
                      className="funeral-methods-method-image"
                    />
                  </div>
                  <h5 className="funeral-methods-method-title">화장</h5>
                  <div className="funeral-methods-method-content">
                    <p className="funeral-methods-method-description">
                      시신이나 발굴된 유골을 불에 태우는 것이다. 법에서 정하는 특별한 경우(사찰 내 화장 의식 등)를 제외하고는 화장시설에서만 화장이 가능하며, 화장 후에는 유골을 매장하거나 자연산포한다.
                    </p>
                  </div>
                </div>

                {/* Exhumation Method */}
                <div className="funeral-methods-method-item">
                  <div className="funeral-methods-method-image-container">
                    <img
                      src="/images/fu3.png"
                      alt="개장"
                      className="funeral-methods-method-image"
                    />
                  </div>
                  <h5 className="funeral-methods-method-title">개장</h5>
                  <div className="funeral-methods-method-content">
                    <p className="funeral-methods-method-description">
                      매장된 시신이나 유골을 다른 묘지나 시설로 이장하거나, 화장하거나 자연산포하는 것이다.
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </main>

    </div>
  );
};

export default FuneralMethodsMobile; 